export default "__VITE_ASSET__D58HauHA__"